import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Logo from '../assets/MALogo.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { signIn } from '../auth/authService';
import ToastNotification from '../components/ToastNotification';
import { checkSession } from '../auth/authService';

const LogIn = () => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [serverMessage, setServerMessage] = useState(''); // State to hold error message
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const verifySession = async () => {
            const sessionActive = await checkSession();
            if (sessionActive) {
                navigate('/'); // Redirect to home if session is active
            }
        };
        verifySession();
    }, [navigate]);

    const handleSubmit = async (event) => {
        // Handle form submission
        event.preventDefault();

        setIsLoading(true);

        if(!email || !password) {
            setServerMessage({success: false, message: 'Please fill in all fields'});
            setIsLoading(false);
            return;
        } else {
            const response = await signIn(email, password);
            if(response.success === true) {
                setServerMessage(response);
                navigate('/');
            } else {
                setServerMessage({success: false, message: response.message});
            }
        }
        setIsLoading(false);
    }

    return (
        <div className="wrapper">
            <div className="d-flex justify-content-center" style={{paddingTop: "40px", cursor: "pointer"}} onClick={() => navigate('/')}>
                <img src={Logo} alt="Melee Academy Logo" style={{width: "50px", marginRight: "12px"}}/>
                <h2 style={{fontWeight: 600}}>Melee Academy</h2>
            </div>

            <div className='background-grid d-flex flex-column justify-content-center align-items-center landscape-spacing' style={{minHeight: "80vh"}}>
                <div className='d-flex flex-column custom-container'>
                    <h2 className='pb-3 text-center' style={{fontWeight: 400}}>Sign In</h2>
                    <input
                        className="custom-input rounded"
                        type="text"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={{ marginBottom: "20px", height: "45px", backgroundColor: "#171A29" }}
                    />
                    <div style={{ position: "relative", marginBottom: "20px" }}>
                        <input
                            className="custom-input rounded"
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            onFocus={(e) => (e.target.style.borderColor = "#FFCC19")} // Change border color on focus
                            onBlur={(e) => (e.target.style.borderColor = "#3C3E4C")} // Reset border color on blur
                            style={{
                                height: "45px",
                                backgroundColor: "#171A29",
                                width: "100%", // Ensure the input takes the full width of the container
                                paddingRight: "40px", // Add padding to make space for the icon
                                border: "1px solid #3C3E4C",
                                color: "white",
                            }}
                        />
                        <FontAwesomeIcon
                            icon={showPassword ? faEyeSlash : faEye} // Toggle between eye and eye-slash icons
                            onClick={() => setShowPassword(!showPassword)} // Toggle password visibility
                            style={{
                                position: "absolute",
                                right: "10px", // Position the icon 10px from the right edge of the input
                                top: "50%", // Center the icon vertically
                                transform: "translateY(-50%)", // Adjust for vertical centering
                                cursor: "pointer",
                                color: "#AEAFBA",
                                width: "20px",
                                height: "20px",
                            }}
                        />
                    </div>
                    <a href='/forgot-password' className='mb-5' style={{color: '#FFCC19', fontWeight: 600}}>Forgot Password?</a>
                    <button className='rounded w-100' style={{backgroundColor: '#FFCC19', height: "45px", fontWeight: 600, border: "none", color: "black"}} disabled={isLoading} onClick={(e) => handleSubmit(e)}>Sign In</button>
                    <p className='text-center mb-0' style={{color: '#AEAFBA', fontWeight: 400, fontSize: "14px", marginTop: "20px"}}>Don't have an account? <a href='/register' style={{color: 'white', fontWeight: 600, textDecoration: 'none'}}>Sign Up</a></p>
                </div>
            </div>
            {/* Toast Notification */}
            <ToastNotification
                message={serverMessage} 
                setServerMessage={setServerMessage}
            />
        </div>
    )
}

export default LogIn